/**
 * PWAUpdatePrompt Component
 *
 * Shows a notification when a new version of the app is available.
 * Allows users to refresh and get the latest version.
 */

import { useTranslation } from 'react-i18next';
import { useRegisterSW } from 'virtual:pwa-register/react';
import styles from './PWAUpdatePrompt.module.css';

export function PWAUpdatePrompt() {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration) {
      console.log('[PWA] Service worker registered:', registration);
      // Check for updates every hour
      if (registration) {
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);
      }
    },
    onRegisterError(error) {
      console.error('[PWA] Service worker registration error:', error);
    },
  });

  const handleUpdate = () => {
    updateServiceWorker(true);
  };

  const handleClose = () => {
    setNeedRefresh(false);
  };

  if (!needRefresh) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <span className={styles.message}>{t('common.pwa.newVersionAvailable')}</span>
        <div className={styles.actions}>
          <button className={styles.updateButton} onClick={handleUpdate}>
            {t('common.pwa.update')}
          </button>
          <button className={styles.closeButton} onClick={handleClose}>
            {t('common.pwa.later')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PWAUpdatePrompt;
